import React from 'react'
import { Leveling } from './leveling'

import '@maxroll-media-group/common-libs/dist/assets/css/style.css'
import '../common-styles.scss'
import './viewer.scss'

import Store from 'store'

import Session from 'store/session'

import { Api } from '@/api'
import EditingContext from 'store/editingContext'
import OverlayRoot from 'ui/utils/OverlayManager'
import { levelingStores } from './common'

function LevelingApp({ stores, metadataId }: { stores: Record<string, Store>; metadataId: string }) {
  const leveling = Store.useEmbed()
  if (!leveling || leveling.type !== 'leveling') return null

  return <Leveling embed={leveling} stores={stores} metadataId={metadataId} />
}

const session = new Session()

export function LevelingComponent({ embedId, profileId }: { embedId: number; profileId: string }) {
  const [loaded, setLoaded] = React.useState(false)
  const [stores, setStores] = React.useState<Record<string, Store>>({})
  const parentStore = Store.useInstance()

  React.useEffect(() => {
    let current = true
    levelingStores(parentStore).then((stores) => {
      if (!current || !stores) return
      new Api(session.dispatch).updateLoginFrontend()
      setStores(stores)
      setLoaded(true)
    })
    return () => {
      current = false
    }
  }, [parentStore])

  const editingContext = new EditingContext()

  return loaded ? (
    <Session.Provider store={session}>
      <EditingContext.Provider context={editingContext}>
        <OverlayRoot>
          <LevelingApp stores={stores} metadataId={`${profileId}:${embedId}`} />
        </OverlayRoot>
      </EditingContext.Provider>
    </Session.Provider>
  ) : null
}
